// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"386":"3c453048","871":"9653eff8"}[chunkId] + ".css";
};